import { IoDocumentTextOutline } from "react-icons/io5";
import Image from "../../../../components/Image/Image.component";
import { API_LINK } from "../../../../utils/fetch.util";

interface Props {
  reportAnswerImages: any;
  setReportAnswerImages: any;
}

export default function ReportsAnswerImages({reportAnswerImages, setReportAnswerImages}: Props) {
  return (
    <>
      {reportAnswerImages.length > 0 && (
        <div
          className="fixed top-0 left-0 z-[99999] w-full h-full bg-black bg-opacity-50 flex justify-center items-center"
          onClick={() => setReportAnswerImages([])}
        >
          <div
            className="bg-white p-4 rounded-lg max-w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-end -mt-3 mb-4">
              <button
                className="text-5xl font-bold text-red-500"
                onClick={() => setReportAnswerImages([])}
              >
                &times;
              </button>
            </div>
            <div className="flex gap-10 overflow-x-auto">
              {reportAnswerImages.map((pic: any) => {
                if (
                  pic.question_picture_url.endsWith(".jpg") ||
                  pic.question_picture_url.endsWith(".png") ||
                  pic.question_picture_url.endsWith(".jpeg")
                ) {
                  return (
                    <Image
                      className="h-[550px] w-fit object-contain"
                      src={pic.question_picture_url}
                      alt="Question Image"
                    />
                  );
                  // } else if (pic.question_picture_url.endsWith(".pdf")) {
                  //   return (
                  //     <a href={API_LINK + pic.question_picture_url} target="_blank">
                  //     </a>
                  //   )
                } else {
                  return (
                    <a
                      href={API_LINK + pic.question_picture_url}
                      target="_blank"
                      className="h-[550px] min-w-[250px] bg-secondary hover:opacity-75 duration-200 grid place-content-center"
                    >
                      <IoDocumentTextOutline className="text-5xl text-text" />
                    </a>
                  );
                }
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
